import React, { ReactElement } from 'react';

import { isMaleGender } from 'helpers/utils';

import { Button } from 'libComponents';
import { Image } from 'components/Image';

import styles from './GenderOption.module.css';

import { IGenderOptionProps } from './types';

function GenderOption(props: IGenderOptionProps): ReactElement {
    const { buttonSmall, onClick, images, dataLocator, gender, buttonTitle } = props;

    const onClickHandle = () => {
        onClick && onClick();
    };

    const isMale = isMaleGender(gender);

    return (
        <div className={styles.genderBox} onClick={onClickHandle}>
            <div className={styles.genderImageBox}>
                <Image loading="eager" sources={images.sourceConfig} src={images.fallbackImageUrl} alt={images.alt} />
            </div>
            <Button
                withPulsating
                dataLocator={dataLocator}
                backgroundColor={isMale ? 'primary-default' : 'secondary-default'}
                text={buttonTitle}
                size={buttonSmall ? 'small' : 'medium'}
            />
        </div>
    );
}

export default GenderOption;
